import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=a37dba3c&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=js&"
export * from "./Stage.vue?vue&type=script&lang=js&"
import style0 from "./Stage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Stage.vue?vue&type=style&index=1&id=a37dba3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37dba3c",
  null
  
)

export default component.exports